import axios from "axios";

const getAllPokemons = async (position, limited) => {
  const URL = `https://pokeapi.co/api/v2/pokemon?offset=${position}&limit=${limited}`;
  const req = await axios.get(URL);
  return req;
};

export default getAllPokemons;
